import { LabelProps } from 'recharts';

import { Typography } from '@ui/uikit/components/common/Typography';

interface ViewBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

const isViewBox = (viewBox: any): viewBox is ViewBox => {
  return viewBox && typeof viewBox.x === 'number' && typeof viewBox.height === 'number';
};

export const ChartYAxisLabel = (props: LabelProps) => {
  const { viewBox, value } = props;

  if (!isViewBox(viewBox)) {
    return null;
  }

  const yPosition = viewBox.y + viewBox.height - Number(value) * (viewBox.height / 100);

  return (
    <foreignObject height={24} width={60} y={yPosition - 12} x={viewBox.width}>
      <div
        className="py-1 rounded-[4px] h-[24px] flex items-center justify-center"
        style={{ backgroundColor: 'rgb(var(--colors-base-text-blue)' }}
      >
        <Typography
          variant="caption-xs"
          color="white"
          isEllipsis
          title={value ? value.toString() : ''}
        >
          {value}
        </Typography>
      </div>
    </foreignObject>
  );
};
